import styled from 'styled-components';

interface Props {
  readonly wasWatched?: boolean;
}

const VideoPlayWrapperStyles = styled.div<Props>`
  border: ${({ wasWatched }: Props): string => (wasWatched ? 'none' : '5px solid rgba(255, 255, 255, 0.4)')};
  border-radius: 50%;
  width: ${({ wasWatched }: Props): string => (wasWatched ? '40px' : '48px')};
  height: ${({ wasWatched }: Props): string => (wasWatched ? '40px' : '48px')};
  position: absolute;
  background: ${({ wasWatched }: Props): string => (wasWatched ? 'rgba(0, 184, 101, 0.7)' : 'none')};
  z-index: 100;
  top: ${({ wasWatched }: Props): string => (wasWatched ? '23%' : '17%')};
  left: ${({ wasWatched }: Props): string => (wasWatched ? '38%' : '34%')};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default VideoPlayWrapperStyles;
